const ImageAssets = {
    Back: require("./back.png"),
    Close: require("./close.png"),
    Hamburger: require("./hamburger.png"),
    HamburgerWhite: require("./hamburger-white.png"),
    Loading: require("./loader.png"),
    Tick: require("./tick.png")
};

export default ImageAssets;